export default __webpack_public_path__ + "linkedin.4a0200c6.png";